import styled, { css } from 'styled-components';

import { getFontColor } from './utils/colors';

export const StyledTagList = styled.div`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    justify-content: space-between;
  }
`;

export const DeleteButton = styled.div`
  z-index: 10;
  position: absolute;
  right: 0;
  top: 0;
  width: 1.6em;
  height: 1.6em;
  text-align: center;
  border-radius: 50%;
`;

type StyledTagProps = {
  size?: 'small' | 'large' | 'medium';
  highlight?: boolean;
  $color?: string;
};

export const StyledTag = styled.div<StyledTagProps>`
  display: inline-block;
  position: relative;
  background-color: ${({ theme, $color }) => $color || theme.colors.N60};
  color: ${({ theme, $color }) => getFontColor($color || theme.colors.N60)};
  border-radius: 5px;
  border: 2px transparent solid;
  border-color: ${({ highlight, theme, $color }) =>
    highlight ? getFontColor($color || theme.colors.N60) : $color};
  &:hover {
    border-color: ${({ theme, $color }) =>
      getFontColor($color || theme.colors.N60)};
  }
  ${({ size }) => {
    switch (size) {
      case 'small':
        return css`
          font-size: 10px;
          padding: 3px 8px;
          border-width: 1px;
        `;
      case 'large':
        return css`
          font-size: 16px;
          padding: 8px 18px;
        `;
      case 'medium':
      default:
        return css`
          font-size: 14px;
          padding: 6px 12px;
        `;
    }
  }};

  ${DeleteButton} {
    background-color: ${({ theme, $color }) => $color || theme.colors.N60};
    color: ${({ theme, $color }) => getFontColor($color || theme.colors.N60)};

    transition: transform 250ms ease-out, opacity 200ms;
    opacity: 0;
    transform: translate(20%, -20%);
  }
  &:hover {
    cursor: ${({ onClick }) => onClick && 'pointer'};
    ${DeleteButton} {
      opacity: 1;
      transform: translate(40%, -40%);
    }
  }
`;
